import { Component, OnInit,OnDestroy ,HostListener, ViewChild, Renderer2} from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup,ValidatorFn,Validators } from '@angular/forms';
import { Route, Router,ActivatedRoute } from '@angular/router';
import { iif } from 'rxjs';
import jwt from 'jwt-decode' 
import  { Amplify,Auth, API } from 'aws-amplify';
import { environment } from "../../../environments/environment"
import { IUser, CognitoService } from '../../services/cognito.service';
import { LoginService } from 'src/app/services/login.service';
import { ColorsService } from 'src/app/services/colors.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { HttpErrorResponse } from '@angular/common/http';
import awsconfig from "../../../aws-exports";
import { UserService } from 'src/app/services/user.service';
import { ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { FullstoryService } from 'src/app/services/fullstory.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit ,OnDestroy {
  username :  string|undefined;
  password : string|undefined;
  loginFG! : FormGroup
  loading: boolean;
  user: IUser;
  invalidCredentialMsg:boolean
  isVerifying:boolean=false;
  isPasswordReset:boolean=false;
  errorMsg="";
  UserId:any;
  selectedTAB:any='services';
  show: boolean = false;
  passwordResetSuccessMsg="";
  userGroup:any="";
  loginName:any="Corporate Login"
  PrimaryColor:any
  constructor(private renderer: Renderer2,private fullStoryService: FullstoryService,private fb : FormBuilder,private ColorsService:ColorsService,
    private cognitoService: CognitoService,
    private loginService : LoginService,
    private router : Router,private route: ActivatedRoute,
    private userinfo : UserInfoService,    private userservice : UserService,
    private toastMsgService:ToastmsgService
    ) {
      this.PrimaryColor= this.ColorsService.loginColors().then((color:any) => {
       this.PrimaryColor=color.PrimaryColor
      })
      .catch((error:any) => {
      });//this.ColorsService.PrimaryColor
      Auth.configure(awsconfig);
      this.loading = false;
      this.user = {} as IUser;
      this.invalidCredentialMsg =false;
     const currentRoute = this.route?.snapshot?.routeConfig?.path;

    // Determine the value of this.variable based on the current route
    if (currentRoute === 'partner_login') {
      this.loginName='Welcome Partner'
    } else if (currentRoute === 'corporate_login') {
      this.loginName='Corporate Login'
    }else if(currentRoute === 'corporate_login'){

    }
  }
  ngOnInit(): void {
    // this.showSlides();
    this.startSlideShow();

    this.loginFG=this.fb.group({
      //"username" :  ['',[Validators.required,Validators.email]],
      "username" :  ['',[Validators.required]],
      "password" : ['',Validators.required],
    })
    
  }
  isMenuOpen: boolean = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }


  async userPrivileges(userType:any): Promise<any>{ 
    let userPrivileges:any
    try {
      let res:any
      userType=userType.toUpperCase()
      if(userType==='EMPLOYEE'){
        res = await this.userservice.getUserTravellerPrivileges()
      }else{
       res = await this.userservice.getUserPrivileges()
      }
       //  console.log(res)
            // Your existing logic here...
            userPrivileges = res.result;
            return userPrivileges;  
        }catch (error) {
          console.error('Error fetching data:', error);
        }
        return userPrivileges;
  }



  login() {
/*
this.user.email = this.loginFG.value.username
this.user.password = this.loginFG.value.password
    this.cognitoService.signIn(this.user)
    .then((data) => {
      this.userinfo.setToken(data.signInUserSession.idToken.jwtToken);
      this.router.navigate(["/app"]);
      
    }).catch((error: HttpErrorResponse) => {

      if(error.message==='Password reset required for the user'){
        this.errorMsg="Password Reset Required";
        this.isPasswordReset=true;
        this.cognitoService.forgotPassword(this.user)
      }else{
      this.loading = false;
      this.invalidCredentialMsg=true
      this.errorMsg="Invalid Username or Password";
      }
    });*/
    this.loginService.login(this.loginFG.value)
      .subscribe({next : (res)=> {
        if(res.status==200) { 
         const body : any = res.body;
         if(body.token) {
          // console.log(body)
          let parentUser=undefined;
          if(body.parentUser){
            parentUser=body.parentUser
          }
          this.userinfo.setToken(body["token"]);
          let userType:any=this.userinfo.getUserType()
          sessionStorage.setItem('loginUserType', userType);

          this.userPrivileges(userType).then((userPrivileges:any) => {
            //console.log(userPrivileges)
            if(userPrivileges){
            this.userinfo.setUserPrivileges(userPrivileges);
            }

            this.ENABLE_TRIP_MGMT()
          
            const userProperties = {
              displayName: this.userinfo.getUserDisplayname(),
              email:this.userinfo.getUsername(),
              reviewsWritten: 14
            };
            

    // sessionStorage.getItem('loginUserType')
            // this.fullStoryService.setIdentity(this.userinfo.getUserUuid(), userProperties);
          

         } )
           .catch((error:any) => {
           console.error(error); // Handle errors, if any
           });

          // window.location.href="/app/flight"
          //this.router.navigate(["/app/flight"]);
          const userData:any = jwt(body["token"]);
          /*if(userData?.companies.length>0){
            sessionStorage.setItem("userData",JSON.stringify(userData));
            let companyCode = []
            for(let i=0;i< userData?.companies.length;i++){
              companyCode.push(userData?.companies[i].companyCode);
            }
            let companycode = companyCode.join(',');
            sessionStorage.setItem("companyCodes",JSON.stringify(companycode));
  
          }*/
        }
        } else {
          this.loginErrorResponseStatus(res);
        }
    }, error : (err)=> {
      this.loginErrorResponseStatus(err);
    }})
  }

  tripEnable:boolean=false
ENABLE_TRIP_MGMT(){

    this.userservice.ENABLE_TRIP_MGMT()
    .subscribe({
      next : (res:any) => {
        if(res) {
       if(res.policyType==='TRIP_MGMT'){
        if(res.rule==='1'){
          
this.tripEnable=true

if(this.userinfo.getUserType()==='Employee')
{
  if(this.tripEnable===true){
  this.router.navigate(["/app/trip"]);}
  else{
    this.router.navigate(["/app/flight"]);

  }

}else{
 this.router.navigate(["/app/flight"]);

}
// console.log(this.tripEnable)

        }else if(res.rule==='2'){
          this.tripEnable=true

          if(this.userinfo.getUserType()==='Employee')
          {
            if(this.tripEnable===true){
            this.router.navigate(["/app/trip"]);}
            else{
              this.router.navigate(["/app/flight"]);
          
            }
          
          }else{
           this.router.navigate(["/app/flight"]);
          
          }
        }
          else{
          this.tripEnable=false
          this.router.navigate(["/app/flight"]);

        }


       }
 
      }else{
        this.router.navigate(["/app/flight"]);

      }},error : (err) => {
        this.router.navigate(["/app/flight"]);

        console.error("Error in fetching data");
      }
    }
  )
  
}
  loginErrorResponseStatus(res : any) {
    if(res.status==401) {
      this.toastMsgService.setMsg({msg : "Invalid Username or Password!",msgTitle : "Warning", msgType : "W"});

      this.invalidCredentialMsg=true;
    } 
  }
// <!--############################--->
  maze: number[][] = [
    [2, 1, 0, 3, 1,0, 1, 0, 3, 1],
    [0, 1, 1, 0, 1,0, 1, 1, 0, 1],
    [0, 1, 0, 0, 1,0, 0, 0, 0, 0],
    [0, 1, 0, 1, 1,0, 1, 1, 1, 0],
    [0, 0, 0, 0, 1,0, 0, 0, 1, 0],
    [1, 1, 0, 0, 0,0, 1, 0, 0, 1],
    [0, 1, 1, 1, 1,1, 1, 1, 0, 1],
    [3, 0, 3, 0, 3,0, 3, 1, 0, 0],
    [1, 0, 0, 0, 1,1, 3, 1, 1, 0],
    [3, 1, 0, 0, 1,0, 0, 0, 0, 0],
    [0, 1, 0, 1, 1,0, 1, 1, 1, 3],
    [0, 0, 1, 0, 0,0, 0, 1, 0, 0],
    [1, 0, 1, 1, 1,1, 0, 1, 1, 3],
    [0, 0, 0, 0, 0,0, 0, 0, 1, 3]
  ];

  playerPositionX = 0;
  playerPositionY = 0;
  coinsCollected = 0;
  totalCoins = this.countCoins();

  @HostListener('document:keydown', ['$event'])
  handleKey(event: KeyboardEvent) {
    switch (event.key) {
      case 'ArrowUp':
        this.movePlayer(-1, 0);
        break;
      case 'ArrowDown':
        this.movePlayer(1, 0);
        break;
      case 'ArrowLeft':
        this.movePlayer(0, -1);
        break;
      case 'ArrowRight':
        this.movePlayer(0, 1);
        break;
    }
  }

  movePlayer(deltaY: number, deltaX: number) {
    const newY = this.playerPositionY + deltaY;
    const newX = this.playerPositionX + deltaX;
    if (this.isValidMove(newY, newX)) {
      this.playerPositionY = newY;
      this.playerPositionX = newX;
      if (this.maze[newY][newX] === 3) {
        this.collectCoin();
      } else if (this.maze[newY][newX] === 2) {
        this.completeMaze();
      }
    }
  }

  isValidMove(y: number, x: number): boolean {
    if (y < 0 || y >= this.maze.length || x < 0 || x >= this.maze[0].length) {
      return false; // Out of bounds
    }
    return this.maze[y][x] !== 1; // Not a wall
  }

  countCoins(): number {
    let count = 0;
    this.maze.forEach(row => {
      row.forEach(cell => {
        if (cell === 3) {
          count++;
        }
      });
    });
    return count;
  }

  collectCoin() {
    this.coinsCollected++;
    this.maze[this.playerPositionY][this.playerPositionX] = 0;
    if (this.coinsCollected === this.totalCoins) {
      this.maze= [
        [2, 1, 0, 0, 1,0, 1, 0, 0, 1],
        [0, 1, 1, 0, 1,0, 1, 1, 0, 1],
        [0, 1, 0, 0, 1,0, 0, 0, 0, 0],
        [0, 1, 0, 1, 1,0, 1, 1, 1, 0],
        [0, 0, 0, 0, 1,0, 0, 0, 1, 0],
        [1, 1, 0, 0, 0,0, 1, 1, 0, 1],
        [0, 1, 1, 1, 0,1, 1, 1, 0, 1],
        [0, 0, 0, 0, 0,0, 0, 1, 0, 0],
        [1, 0, 0, 0, 1,1, 0, 1, 1, 0],
        [0, 1, 0, 0, 1,0, 0, 0, 0, 0],
        [0, 1, 0, 1, 1,0, 1, 1, 1, 0],
        [0, 0, 1, 0, 0,0, 1, 1, 0, 0],
        [1, 0, 1, 1, 1,1, 0, 1, 1, 0],
        [0, 0, 0, 0, 0,0, 0, 0, 1, 1]
      ];
      
    }
  }

  completeMaze() {
    if (this.coinsCollected === this.totalCoins) {
      alert('Congratulations! You completed the maze and collected all coins.');
    } else {
      alert('You need to collect all coins before completing the maze.');
    }
  }

  openPopup() {
   
  this.show=true
  }
  closePopup() {
    this.show=false
  }
  sendEmail(){
    this.loginService.getPasswordLink(this.UserId)
    .subscribe({next : (res)=> {
      
      let data:any={message:"",success:""}
       data = res
       if(data.message==="Mail send successfully"){
        this.show=false
        this.toastMsgService.setMsg({msg : "Password reset link sent successfully",msgTitle : "Success",msgType : "I"});

       }else{
        this.toastMsgService.setMsg({msg : data.message,msgTitle : "Warning", msgType : "W"});

       }

    },error : (err) => {
      
      this.toastMsgService.setMsg({msg : "Failed to Send",msgTitle : "Warning", msgType : "W"});

      }})
  }

  currentSlide = 0;
  slideInterval: any;

  startSlideShow() {
    this.showSlides();
    this.slideInterval = setInterval(() => this.showSlides(), 5000); // Change image every 5 seconds
  }

  showSlides() {
    let slides: any = document.getElementsByClassName('slider')[0].getElementsByTagName('img');
    for (let i = 0; i < slides.length; i++) {
      slides[i].classList.remove('active');
    }
    this.currentSlide++;
    if (this.currentSlide > slides.length) { this.currentSlide = 1; }
    slides[this.currentSlide - 1].classList.add('active');
  }

  stopSlideShow() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
      this.slideInterval = null;
    }
  }
  ngOnDestroy(): void {
    this.stopSlideShow();
  }
  prevSlide() {
    clearInterval(this.slideInterval);
    this.navigateSlides(-1);
    this.startSlideShow();
  }

  nextSlide() {
    clearInterval(this.slideInterval);
    this.navigateSlides(1);
    this.startSlideShow();
  }

  navigateSlides(n: number) {
    let slides: any = document.getElementsByClassName('slider')[0].getElementsByTagName('img');
    slides[this.currentSlide - 1].classList.remove('active');
    this.currentSlide += n;
    if (this.currentSlide > slides.length) { this.currentSlide = 1; }
    if (this.currentSlide < 1) { this.currentSlide = slides.length; }
    slides[this.currentSlide - 1].classList.add('active');
  }

  goToSlide(n: number) {
    clearInterval(this.slideInterval);
    this.currentSlide = n;
    this.navigateSlides(0); // Update slide without incrementing
    this.startSlideShow();
  }
  qrData: string = 'https://example.com'
  four:number=4
  three:number=3
  
clientTestimocial:any=[

  {url:"../../../assets/images/loginimg/loginIMG/landing page/Client Testimonial/74.png",name:'Syrma SGS Technology Ltd',id:'card-1',
  title:'We are fully satisfied with their exceptional services & competitive rates for Flight-Domestic & International, Visa, Hotels, Car Bookings & Forex etc. and have had good experience with their Services.',color:"#fafafa"},
  {url:"../../../assets/images/loginimg/loginIMG/landing page/Client Testimonial/73.png",name:'Culver Max Entertainment Pvt Ltd',id:'card-2',
  title:'They have successfully completed tool integration for Air ticketing services. They are also managing hotels, visas, car, MICE etc and we have had good experience of their services.',color:"#fafafa"},
  {url:"../../../assets/images/loginimg/loginIMG/landing page/Client Testimonial/76.png",name:'Infrasoft Technologies Ltd',id:'card-3',
  title:'They have been successfully handling business volume of more than 8 Crore p.a. by rendering travel services for air/road/rail bookings, accommodation arrangements, travel insurance and VISA applications.',color:"#fafafa"},
  {url:"../../../assets/images/loginimg/loginIMG/landing page/Client Testimonial/75.png",name:'Total Oil India Pvt. Limited',id:'card-4',
  title:'They have been effective & successfully handling our volume of more than 15 Crores per annum in rendering travel services for Air, hotel , Insurance, visa and we share a good experience with them on service levels .',color:"#fafafa"},
  {url:"../../../assets/images/loginimg/loginIMG/landing page/Client Testimonial/77.png",name:'PerkinElmer (India) Private Limited',id:'card-5',
  title:'They have successfully been providing us services for Air Travel, Hotel Accommodation, Car, Insurance, Visa, Forex etc., and we have had good experience with their Services.',color:"#fafafa"},

]


  chooseUsimg:any=[
    {url:"../../../assets/images/loginimg/icon/8.png",
  title:'Live online inventory',color:"#fafafa"}
  ,{url:"../../../assets/images/loginimg/icon/9.png",
  title:'Mobile Friendly/ app',color:"#f5f5f5"},
  {url:"../../../assets/images/loginimg/icon/10.png",
  title:'24/7 service',color:"#f0f0f0"},
  {url:"../../../assets/images/loginimg/icon/11.png",
  title:'Best ROE for Forex',color:"#e8e8e8"},
  {url:"../../../assets/images/loginimg/icon/11.png",
  title:'Best ROE for Forex',color:"#fafafa"},
  {url:"../../../assets/images/loginimg/icon/12.png",color:"#f5f5f5",
  title:'All Travel Services Under Single Roof'},
  {url:"../../../assets/images/loginimg/icon/14.png",
  title:'Automation of maximum services',color:"#e8e8e8"},
  {url:"../../../assets/images/loginimg/icon/13.png",
  title:'Largest network of global airline, Wholesalers and car rentals.',color:"#f0f0f0"},]

  // @ViewChild('carousel') carousel: any;
  // private startX: number | null = null;
  // private isDragging = true;

  // onMouseDown(event: MouseEvent) {
  //   this.startX = event.clientX;
  //   this.isDragging = true;
  // }

  // onMouseUp(event: MouseEvent) {
  //   if (this.isDragging && this.startX !== null) {
  //     const endX = event.clientX;
  //     const deltaX = endX - this.startX;
  //     if (Math.abs(deltaX) > 50) {  // Adjust threshold as needed
  //       if (deltaX < 0) {
  //         this.carousel.next();  // Slide to next
  //       } else {
  //         this.carousel.prev();  // Slide to previous
  //       }
  //     }
  //   }
  //   this.isDragging = false;
  //   this.startX = null;
  // }

  // onMouseMove(event: MouseEvent) {
  //   if (this.isDragging && this.startX !== null) {
  //     // Optionally, you can add visual feedback here
  //   }
  // }
  onClickRegister(){
    let url='https://register.gilpinonline.com/newprofile?id=853e4185-cd0b-46cb-b938-0132b8cf84f3'
    window.open(url);  }


    private currentIndex = 0;
  private cardIds = ['card-1', 'card-2', 'card-3','card-4','card-5'];


 onClickChange(){
    //  // Remove the hover effect from all cards
    //  this.cardIds.forEach((id) => {
    //   const card = document.getElementById(id);
    //   this.renderer.removeClass(card, 'auto-hover');
    // });

    // // Add hover effect to the current card
    // const currentCard = document.getElementById(this.cardIds[this.currentIndex]);
    // this.renderer.addClass(currentCard, 'auto-hover');

    // // Update the index
    // this.currentIndex = (this.currentIndex + 1) % this.cardIds.length;

    // // Scroll to the current card
    // currentCard?.scrollIntoView({ behavior: 'smooth', inline: 'center' });
 }

 ngAfterViewInit() {
  const wrapper:any= document.querySelector('.logos-wrapper');
  const logos = wrapper.innerHTML;
  wrapper.innerHTML += logos; 

  
}
}
